export default {
  title: 'Formatos de la aseguradora',
  subtitle: 'Seleccione el formato que necesite de la lista a continuación.',
  purpose: 'Estos documentos son proporcionados por la aseguradora para diferentes procesos relacionados con su póliza.'
}
